module.exports = __webpack_public_path__ + "static/img/makehole5.2ffb0397.png";